// Function is used on Progressive users to format the reference number put on the report.
// The current logic is there must be a dash at the third position and the total length of the reference number
// cannot exceed 12 characters.
const normalizeReferenceNumber = (value) => {
  if (!value) {
    return value;
  }

  const onlyNums = value.replace(/[^\d]/g, '');

  if (onlyNums.length <= 2) {
    return `${onlyNums}`;
  }

  if (onlyNums.includes('-')) {
    return `${onlyNums.slice(0, 12)}`;
  }

  return `${onlyNums.slice(0, 2)}-${onlyNums.slice(2, 11)}`;

};

export default normalizeReferenceNumber;


// WEBPACK FOOTER //
// ./src/helpers/NormalizeReferenceNumber.js